module.exports = __webpack_public_path__ + "img/Jasper - Talk 2.a3ff2d8d.png";